import { imageApplyDataAttr } from './helpers.js'

const ratio = 1.33
const campers = document.querySelectorAll( 'article.camper' )

/**
 * Init the abstacts
 */
function init()
{
  //image sizes
  window.addEventListener( 'resize', setImageSizes )

  //observer
  const observer = new IntersectionObserver( entries => {
    entries.forEach( ({ isIntersecting, target }) => {

      if( isIntersecting && !target.classList.contains( 'active' ) )
      {
        const picture = target.querySelector( 'picture' )

        picture.style.backgroundImage = `url('${picture.getAttribute( 'data-brand' )}')`

        const image = picture.querySelector( 'img' )


        if( image ){
          imageApplyDataAttr( image, ({ target }) => {
            target.classList.add( 'active' )
          })
        }

        target.classList.add( 'active' )
      }
    })
  })

  //observer
  campers.forEach( camper => {
    observer.observe( camper )
  })

}

function setImageSizes()
{
  campers.forEach( camper => {
    const { clientWidth: width } = camper

    camper.querySelector( 'picture a' ).style.height = Math.round( width / ratio ) + 'px'
  })
}

export default {
  init,
}

